import { render, staticRenderFns } from "./document-page.vue?vue&type=template&id=ab353744&"
import script from "./document-page.vue?vue&type=script&lang=js&"
export * from "./document-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports